<template>
  <div>
    <vx-card class="mt-base mb-5" :title="activityTitle">
      <p class="mb-5">
        Many entrepreneurial projects fail because they neglected to make sure they had defined the
        problem they were trying to solve, or because there was no demand for a solution.
      </p>
      <p class="mb-5">
        This exercise is designed to help you flesh out what the problem (or opportunity is), which
        can help you fine-tune your product or your marketing strategy.
      </p>
      <p class="mb-5">
        For this exercise, try to answer the following questions about the problem your business
        idea (or the example business idea) is trying to solve. Try and be as specific as you can -
        if you can find statistics, numbers and facts to back up your answer, even better!
      </p>

      <ol class="numbered-list">
        <li><strong>What</strong> is the problem being experienced?</li>
        <li><strong>Who</strong> is experiencing the problem?</li>
        <li>
          <strong>Where</strong> is the problem being experienced? Is it in your local area, your
          city, Australia, or the world?
        </li>
        <li>
          <strong>Why</strong> does the problem exist? Are there any related problems or causes of
          the problem you can identify?
        </li>
        <li>
          <strong>When</strong> are people experiencing this problem? Is it in a specific time or
          situation, or is the problem happening all of the time?
        </li>
        <li><strong>How</strong> is the problem happening?</li>
      </ol>
      <p class="mb-5">
        Next, think about how your product or service could add or change its features to address
        all the details of this problem.
      </p>

      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_1']"
        :is-editable="isEditable"
        filetype="doc"
        index="1"
        key="1"
      />

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
